import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-799b26d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "buttons" }


  import FlipButton from './FlipButton.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'FormButtons',
  props: {
    previous: { type: Boolean },
    next: { type: Boolean },
    send: { type: Boolean }
  },
  emits: ["clickRight", "clickLeft", "clickSend"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'clickRight',): void;
    (e: 'clickLeft',): void;
    (e: 'clickSend',): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    previous?: boolean;
    next?: boolean;
    send?: boolean;
  };

  

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.previous)
      ? (_openBlock(), _createBlock(FlipButton, {
          key: 0,
          class: "button",
          icon: "arrowLeft.svg",
          alt: "Pfeil links",
          label: "zurück",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('clickLeft')))
        }))
      : _createCommentVNode("", true),
    (props.next)
      ? (_openBlock(), _createBlock(FlipButton, {
          key: 1,
          class: "button",
          icon: "arrowRight.svg",
          alt: "Pfeil rechts",
          label: "weiter",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('clickRight')))
        }))
      : _createCommentVNode("", true),
    (props.send)
      ? (_openBlock(), _createBlock(FlipButton, {
          key: 2,
          class: "button",
          icon: "paperPlane.svg",
          alt: "senden",
          label: "senden",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('clickSend')))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})